import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/breadcrum'
import CompanyProfileSection from '../../components/CompanyProfileSection'
import { useQuery } from '@tanstack/react-query'
import { getAllGraph } from '../../api/graphApi'
import toast from 'react-hot-toast'
import LineChart from '../../components/FundRaiseChart'
import { Link } from 'react-router-dom'
import { FaPlus, FaSearch } from 'react-icons/fa'
import FundRaiseChart from '../../components/FundRaiseChart'
import FinancialChart from '../../components/FinancialChart'

const Graph = () => {
  useEffect(() => {
    document.title = 'Graph'
  }, [])

  const [searchTerm, setSearchTerm] = useState('')

  const {
    data: graphs = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['graphs'],
    queryFn: getAllGraph,
    onError: (error) => {
      toast.error('Errro While fetching graph')
    },
  })

  const filterGraphs = graphs.filter((graph) => {
    return graph.brandName?.toLowerCase().includes(searchTerm)
  })

  const total = graphs?.length || 0

  if (isLoading) {
    return (
      <>
        <Breadcrum heading="Deal" subheading="Graph" />
        <div className="text-center py-8">Loading graph...</div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum heading="Deal" subheading="Graph" />
        <div className="text-center py-8 text-red-500">
          Error loading graph. Please try again later.
        </div>
      </>
    )
  }

  return (
    <>
      <Breadcrum heading="Deal" subheading="Graph" />

      <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
        <div className="bg-white rounded-md shadow-md p-6 flex justify-center items-center gap-4">
          <Link
            to="/dealdashboard/add/graph"
            className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
            title="Add New"
          >
            <FaPlus />
          </Link>
          <Link
            to="/dealdashboard/add/graph-bulk"
            className="text-sm px-3 py-2 rounded-lg border border-[#ff7010] text-[#ff7010]"
          >
            Add several from DSJ data
          </Link>
        </div>
      </div>

      {filterGraphs && (
        <>
          <div className="fixed right-10 z-40 top-[18%] bg-[#ff7010] rounded-full text-white text-xl w-fit h-fit px-3 py-1 shadow-md">
            {total}
          </div>

          {/* Search and Filter Section */}
          <div className="w-full mx-auto my-6">
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1 relative">
                  <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    type="text"
                    placeholder="Search by Brand name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#ff7010] focus:border-transparent outline-none transition-all"
                  />
                </div>
              </div>
              <div className="mt-4 text-sm text-gray-500">
                Showing {filterGraphs.length} of {graphs.length} Graph
              </div>
            </div>
          </div>

          <div className="bg-white mx-auto mt-5 shadow-inner">
            <div className="grid grid-cols-3 gap-4 bg-gray-200 my-10">
              {filterGraphs &&
                filterGraphs.map((d, index) => (
                  <div key={index}>
                    <div className="pt-10">
                      <div className="flex justify-between items-center bg-slate-200 border-2 border-slate-300 border-b-0 py-5 px-2 rounded-t-lg text-base">
                        <div>
                          <h3 className="font-aptos-bold">{d?.brandName}</h3>
                          <h5 className="text-gray-500">{d?.cin}</h5>
                        </div>

                        <Link
                          to="/dealdashboard/add/graph"
                          state={{ graphId: d?.id, edit: true }}
                          className="bg-[#ff7010] p-1 text-white font-aptos-semibold rounded-md"
                        >
                          Update
                        </Link>
                      </div>

                      {!d.hideInfoBox && (
                        <CompanyProfileSection
                          brandName={d?.brandName}
                          companyLogoUrl={d?.imageUrl}
                          companyName={d?.companyName}
                          ebitda={d?.ebitda}
                          grossRevenue={d?.grossRevenue}
                          industry={d?.industry}
                          netProfitLoss={d?.netProfitLoss}
                          yearIncorporation={d?.yearIncorporation}
                          id={d?.id}
                        />
                      )}
                    </div>

                    <div className="pt-10">
                      {!d?.hideGraph && (
                        <FinancialChart
                          title={d?.brandName}
                          heading="Financial Performance Analysis"
                          labels={d?.grossYear?.split(',').map((y) => y.trim())}
                          datasets={[
                            {
                              label: 'Gross Operational Revenue',
                              data: d?.grossRevenueData
                                ?.split(',')
                                .map((v) => parseFloat(v) || 0),
                              borderColor: '#ff7010',
                              backgroundColor: 'rgba(255,112,16,0.2)',
                              tension: 0.3,
                            },
                            {
                              label: 'Gross Expenses',
                              data: d?.grossExpensesData
                                ?.split(',')
                                .map((v) => parseFloat(v) || 0),
                              borderColor: '#6366f1',
                              backgroundColor: 'rgba(99,102,241,0.2)',
                              tension: 0.3,
                            },
                            {
                              label: 'Other Income',
                              data: d?.otherIncome
                                ?.split(',')
                                .map((v) => parseFloat(v) || 0),
                              borderColor: '#0D9488',
                              backgroundColor: 'rgba(13,148,136,0.2)',
                              tension: 0.3,
                            },
                          ]}
                        />
                      )}
                    </div>

                    <div className="pt-10">
                      {!d?.hideFundRaise && (
                        <FundRaiseChart
                          title={`${d?.brandName} - Fund Raise`}
                          heading="Overview of Fund Raising"
                          labels={d?.fundRaiseYear
                            ?.split(',')
                            .map((y) => y.trim())}
                          datasets={[
                            {
                              label: 'Fund Raise Amount',
                              data: d?.fundRaiseAmount
                                ?.split(',')
                                .map((v) => parseFloat(v) || 0),
                              borderColor: '#567D46',
                              backgroundColor: 'rgba(86,125,70,0.2)',
                              tension: 0.3,
                            },
                          ]}
                          fundRaiseRound={d?.fundRaiseRound}
                        />
                      )}
                    </div>

                    <div className="col-span-3 border-b-2 border-gray-300"></div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}

      <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
        <div className="bg-white rounded-md shadow-md p-6 flex justify-center items-center gap-4">
          <Link
            to="/dealdashboard/add/graph"
            className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
            title="Add New"
          >
            <FaPlus />
          </Link>
          <Link
            to="/dealdashboard/add/graph-bulk"
            className="text-sm px-3 py-2 rounded-lg border border-[#ff7010] text-[#ff7010]"
          >
            Add several from DSJ data
          </Link>
        </div>
      </div>
    </>
  )
}

export default Graph
